// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Ng_P","content":"styles_content__1m_jQ","selectAll":"styles_selectAll__1DaG7"};